<template>
  <div :class="[$options.name]" :data-e-ga-id="uniqueId">
    <div class="tw:min-w-40 tw:w-full tw:p-3 tw:text-left tw:transition tw:bg-white">
      <div :class="`tw:flex tw:gap-3 tw:items-center tw:justify-between`">
        <div class="tw:flex tw:gap-3 tw:items-center">
          <font-awesome-icon v-if="icon" :icon="icon" style="width: 20px" class="tw:text-default-900" />
          <span class="tw:text-default-700 tw:caption">{{ text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneDropdownHeader",
  props: {
    /**
     * Icon name from font-awesome
     */
    icon: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * Text to display
     */
    text: {
      type: String,
      required: false,
      default: "",
    },
    uniqueId: {
      type: String,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss"></style>
